module.exports = __webpack_public_path__ + "img/section22.313e350b.png";